import { render, staticRenderFns } from "./correlationTest.vue?vue&type=template&id=707c1dec&scoped=true&"
import script from "./correlationTest.vue?vue&type=script&lang=js&"
export * from "./correlationTest.vue?vue&type=script&lang=js&"
import style0 from "./correlationTest.vue?vue&type=style&index=0&id=707c1dec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c1dec",
  null
  
)

export default component.exports